<template>
  <div class="text-left">
    <slot/>
    <div class="df-container">
      <div>
        <input
          ref="dayInput"
          class="dfi"
          :type="isMobileDevice ? 'number' : 'text'"
          placeholder="DD"
          maxlength="2"
          @change="passDate"
          @input="handleInput('day')"
          @blur="handleBlur"
          :value="getDay"
          id="day-input"
        />
        <p class="df-description">
          Day
        </p>
      </div>

      <div>
        <input
          ref="monthInput"
          class="dfi"
          :type="isMobileDevice ? 'number' : 'text'"
          placeholder="MM"
          maxlength="2"
          @change="passDate"
          @input="handleInput('month')"
          @blur="handleBlur"
          :value="getMonth"
          id="month-input"
        />
        <p class="df-description">
          Month
        </p>
      </div>

      <div>
        <input
          ref="yearInput"
          class="dfi dfi-year"
          :type="isMobileDevice ? 'number' : 'text'"
          placeholder="RRRR"
          maxlength="4"
          @change="passDate"
          @input="handleInput('year')"
          @blur="handleBlur"
          :value="getYear"
          id="year-input"
        />
        <p class="df-description">
          Year
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { checkIfDeviceIsMobile } from '@/utils/deviceType.js';

export default {
  name: 'DateField',
  props: {
    value: {
      type: Object,
      required: false,
    },
    blockFutureDate: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isMobileDevice: false,
      currentDate: new Date(),
    };
  },
  mounted() {
    this.isMobileDevice = checkIfDeviceIsMobile();
  },
  computed: {
    getDay() {
      return this.value ? this.format(this.value.day) : '';
    },
    getMonth() {
      return this.value ? this.format(this.value.month) : '';
    },
    getYear() {
      return this.value ? this.format(this.value.year) : '';
    },
  },
  methods: {
    format(number) {
      if (number) {
        return number.toString().padStart(2, '0');
      }
      return '';
    },
    handleBlur() {
      const fieldMap = {
        day: this.$refs.dayInput,
        month: this.$refs.monthInput,
        year: this.$refs.yearInput,
      };

      // Emit blur only when all fields are filled with some value
      if (fieldMap.day.value && fieldMap.month.value && fieldMap.year.value) {
        this.$emit('blur');
      }
    },
    handleInput(fieldName) {
      const currentField = this.$refs[`${fieldName}Input`];
      if (!this.isNumeric(currentField.value)) {
        currentField.value = '';
      }

      const fieldMap = {
        day: this.$refs.monthInput,
        month: this.$refs.yearInput,
        year: null,
      };

      const nextField = fieldMap[fieldName];

      if (this.blockFutureDate) {
        // When is month and year filled and user will insert day, it will check if that date is valid. Otherwise, empty the day input.
        if (currentField.value.length !== 0 && fieldName === 'day') {
          if (this.$refs.yearInput.value && this.$refs.monthInput.value) {
            const newMonth = this.$refs.monthInput.value;
            const newYear = this.$refs.yearInput.value;

            const newDate = new Date(newYear, newMonth - 1, currentField.value);

            if (newDate > this.currentDate) {
              currentField.value = '';
            }
          }
        }

        // When is day and year filled and user will insert month, it will check if that date is valid. Otherwise, empty the month input.
        if (currentField.value.length !== 0 && fieldName === 'month') {
          if (this.$refs.yearInput.value && this.$refs.dayInput.value) {
            const newDay = this.$refs.dayInput.value;
            const newYear = this.$refs.yearInput.value;

            const newDate = new Date(newYear, currentField.value - 1, newDay);

            if (newDate > this.currentDate) {
              currentField.value = '';
            }
          }
        }

        // When is day and month filled and user will insert year, it will check if that date is valid. Otherwise, empty the year input.
        if (currentField.value.length !== 0 && fieldName === 'year') {
          if (this.$refs.monthInput.value && this.$refs.dayInput.value) {
            const newDay = this.$refs.dayInput.value;
            const newMonth = this.$refs.monthInput.value;

            const newDate = new Date(currentField.value, newMonth - 1, newDay);

            if (newDate > this.currentDate) {
              currentField.value = '';
            }
          }
        }
      }

      // Focus the next input when current input is filled
      if (currentField.value.length === currentField.maxLength && nextField) {
        nextField.focus();
      }

      // Blur year input when value is inserted correctly
      if (currentField.value.length === currentField.maxLength && fieldName === 'year') {
        this.$refs.yearInput.blur();
      }
    },
    isNumeric(value) {
      return /^\d+$/.test(value);
    },
    passDate() {
      const fieldMap = {
        day: this.$refs.dayInput,
        month: this.$refs.monthInput,
        year: this.$refs.yearInput,
      };

      const day = fieldMap.day.value;
      const month = fieldMap.month.value;
      const year = fieldMap.year.value;

      this.$emit('input', {
        day: day ? parseInt(day, 10) : null,
        month: month ? parseInt(month, 10) : null,
        year: year ? parseInt(year, 10) : null,
        hour: 0,
        minite: 0,
        second: 0,
      });
    },
  },
};
</script>
